import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "o-grid u-mar-b-3" }
const _hoisted_2 = { class: "o-grid__cell o-grid__cell--12 u-form-grid-nospace-y" }
const _hoisted_3 = { class: "o-grid o-grid--align-center" }
const _hoisted_4 = {
  key: 0,
  class: "o-grid__cell o-grid__cell--12-360 o-grid__cell--4-1024"
}
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "o-grid__cell o-grid__cell--12-360 o-grid__cell--4-1024" }
const _hoisted_7 = ["title"]
const _hoisted_8 = {
  key: 0,
  class: "o-grid__cell o-grid__cell--12-360 o-grid__cell--4-1024"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_beratung_direkt = _resolveComponent("beratung-direkt")!
  const _component_modal = _resolveComponent("modal")!
  const _component_vorschlag_direkt = _resolveComponent("vorschlag-direkt")!
  const _component_vorschlag_makler = _resolveComponent("vorschlag-makler")!
  const _component_buendel_dokument_links = _resolveComponent("buendel-dokument-links")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[12] || (_cache[12] = _createElementVNode("hr", {
      class: "u-mar-y-2",
      style: {"border":"1px solid #959595"}
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (!_ctx.isSafariMobil)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("button", {
                  title: _ctx.beschriftung + (_ctx.piniaStore.state.isMakler === true ? '' : ' als PDF') + ' herunterladen',
                  class: "c-button c-button--inverted c-button--full-width c-button--word-wrap-flex-height",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.vorschlagHerunterladen && _ctx.vorschlagHerunterladen(...args)))
                }, _toDisplayString(_ctx.beschriftung) + " " + _toDisplayString(_ctx.piniaStore.state.isMakler === true ? "" : " als PDF") + " herunterladen ", 9, _hoisted_5)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "c-button c-button--inverted c-button--full-width c-button--word-wrap-flex-height",
              "data-cy": "submitVorschlagPerEmail",
              title: _ctx.beschriftung + (_ctx.piniaStore.state.isMakler === true ? ' versenden' : ' per E-Mail anfordern'),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emailAnfordern && _ctx.emailAnfordern(...args)))
            }, _toDisplayString(_ctx.beschriftung) + " " + _toDisplayString(_ctx.piniaStore.state.isMakler === true ? " versenden" : " per E-Mail anfordern"), 9, _hoisted_7)
          ]),
          _renderSlot(_ctx.$slots, "button-3", {}, () => [
            (_ctx.piniaStore.state.isMakler !== true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "c-button c-button--inverted c-button--full-width c-button--word-wrap-flex-height",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.beratungAnfordern && _ctx.beratungAnfordern(...args)))
                  }, " Ich wün­sche eine per­sön­liche Beratung ")
                ]))
              : _createCommentVNode("", true)
          ], true)
        ])
      ])
    ]),
    (_ctx.istSichtbar('modal-beratungDirekt'))
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          text: "Unser Beratungsteam erstellt Ihnen gern ein individuelles Angebot. Sie erreichen uns von Montag bis Freitag von 8:00 bis 18:00 Uhr.",
          titel: "Jetzt Angebot anfordern",
          onCloseModal: _cache[3] || (_cache[3] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-beratungDirekt')))
        }, {
          inhalt: _withCtx(() => [
            _createVNode(_component_beratung_direkt)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.istSichtbar('modal-vorschlagDirekt'))
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 1,
          text: 
      'Lassen Sie sich einen ' +
      _ctx.beschriftung +
      ' per E-Mail zusenden. Die E-Mail enthält neben dem ' +
      _ctx.beschriftung +
      ' auch einen Link, über den Sie jederzeit in den Tarifrechner zurückkehren können.'
    ,
          titel: 'Ihr ' + _ctx.beschriftung + ' per E-Mail',
          onCloseModal: _cache[5] || (_cache[5] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-vorschlagDirekt')))
        }, {
          inhalt: _withCtx((inhaltProps) => [
            _createVNode(_component_vorschlag_direkt, {
              antrag: _ctx.antrag,
              "is-vorschlag-email": true,
              produkt: _ctx.produkt,
              "ist-outbound-aktiv": _ctx.piniaStore.state.outbound.emailAktiv,
              onCloseModal: _cache[4] || (_cache[4] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-vorschlagDirekt'))),
              onTextVerbergen: inhaltProps.textVerbergenToggle
            }, null, 8, ["antrag", "produkt", "ist-outbound-aktiv", "onTextVerbergen"])
          ]),
          _: 1
        }, 8, ["text", "titel"]))
      : _createCommentVNode("", true),
    (_ctx.istSichtbar('modal-vorschlagMaklerDownload'))
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 2,
          text: 
      'Hier können Sie einen personalisierten ' +
      _ctx.beschriftung +
      ' erstellen. Alle von Ihnen angegebenen Kundendaten werden im ' +
      _ctx.beschriftung +
      ' berücksichtigt und für die spätere Wiederaufnahme automatisch gespeichert.'
    ,
          titel: _ctx.beschriftung + ' herunterladen',
          onCloseModal: _cache[7] || (_cache[7] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-vorschlagMaklerDownload')))
        }, {
          inhalt: _withCtx((inhaltProps) => [
            _createVNode(_component_vorschlag_makler, {
              antrag: _ctx.antrag,
              isVorschlagEmail: false,
              produkt: _ctx.produkt,
              trackingZusatz: _ctx.trackingZusatz,
              onCloseModal: _cache[6] || (_cache[6] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-vorschlagMaklerDownload'))),
              onTextVerbergen: inhaltProps.textVerbergenToggle
            }, null, 8, ["antrag", "produkt", "trackingZusatz", "onTextVerbergen"])
          ]),
          _: 1
        }, 8, ["text", "titel"]))
      : _createCommentVNode("", true),
    (_ctx.istSichtbar('modal-vorschlagDirektDownload'))
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 3,
          text: 
      'Laden Sie hier bequem Ihren ' +
      _ctx.beschriftung +
      ' als PDF herunter.' +
      ' Über den Link im PDF kommen Sie jederzeit einfach in den Tarifrechner zurück.'
    ,
          titel: _ctx.beschriftung + ' herunterladen',
          onCloseModal: _cache[9] || (_cache[9] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-vorschlagDirektDownload')))
        }, {
          inhalt: _withCtx((inhaltProps) => [
            _createVNode(_component_vorschlag_direkt, {
              antrag: _ctx.antrag,
              isVorschlagEmail: false,
              produkt: _ctx.produkt,
              trackingZusatz: _ctx.trackingZusatz,
              "ist-outbound-aktiv": _ctx.piniaStore.state.outbound.downloadAktiv,
              onCloseModal: _cache[8] || (_cache[8] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-vorschlagDirektDownload'))),
              onTextVerbergen: inhaltProps.textVerbergenToggle
            }, null, 8, ["antrag", "produkt", "trackingZusatz", "ist-outbound-aktiv", "onTextVerbergen"])
          ]),
          _: 1
        }, 8, ["text", "titel"]))
      : _createCommentVNode("", true),
    (_ctx.istSichtbar('modal-vorschlagMaklerEmail'))
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 4,
          text: 
      'Lassen Sie sich einen ' +
      _ctx.beschriftung +
      ' per E-Mail zusenden. Die E-Mail enthält neben dem ' +
      _ctx.beschriftung +
      ' auch einen Link, über den Sie jederzeit in den Tarifrechner zurückkehren können.'
    ,
          titel: _ctx.beschriftung + ' per E-Mail versenden',
          onCloseModal: _cache[11] || (_cache[11] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-vorschlagMaklerEmail')))
        }, {
          inhalt: _withCtx((inhaltProps) => [
            _createVNode(_component_vorschlag_makler, {
              antrag: _ctx.antrag,
              isVorschlagEmail: true,
              produkt: _ctx.produkt,
              onCloseModal: _cache[10] || (_cache[10] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-vorschlagMaklerEmail'))),
              onTextVerbergen: inhaltProps.textVerbergenToggle
            }, null, 8, ["antrag", "produkt", "onTextVerbergen"])
          ]),
          _: 1
        }, 8, ["text", "titel"]))
      : _createCommentVNode("", true),
    (_ctx.istSichtbar('modal-ferienhausDownload'))
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 5,
          titel: _ctx.beschriftung + ' herunterladen',
          text: "Download-Links:",
          onCloseModal: _ctx.closeFerienhausDownload
        }, {
          inhalt: _withCtx((inhaltProps) => [
            _createVNode(_component_buendel_dokument_links, {
              antrag: _ctx.antrag,
              trackingZusatz: _ctx.trackingZusatz,
              onTextVerbergen: inhaltProps.textVerbergenToggle
            }, null, 8, ["antrag", "trackingZusatz", "onTextVerbergen"])
          ]),
          _: 1
        }, 8, ["titel", "onCloseModal"]))
      : _createCommentVNode("", true)
  ], 64))
}